import React, { useState } from "react";
import {
  Box,
  Button,
  InputAdornment,
  InputBase,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { cancelIcon, deleteIcon, leftArrow, rightArrow } from "../../../assets";
import { tokens } from "../../../theme";
import styled from "@emotion/styled";

const Container = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  width: "90%",
  height: "80%",
  position: "absolute",
});

const NftRow = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  marginTop: "10px",
});

const LastRow = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
});

const CrossBox = styled(Box)({
  width: "31px",
  height: "31px",
  borderRadius: "31px",
  border: "0.5px solid #6A27EA",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  right: "40px",
  cursor: "pointer",
});

export default function FinalPreview({
  droppedNfts,
  setDroppedNfts,
  isOver,
  selectedNftCopy,
  setSelectedNftCopy,
  scholarAddress,
  split,
  operation,
  currentInstance,
  setCurrentInstance,
  addInstance,
  updateInstance,
  removeInstance,
  instances,
  rewardTokenAddress,
  amount,
  type,
}) {
  const [isBackeSpacePressed, setIsBackeSpacePressed] = useState(false);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const downXl = useMediaQuery(theme.breakpoints.down("xl"));
  const downMd = useMediaQuery(theme.breakpoints.down("md"));

  const splitFormatter = (split) => `${split} %`;

  const NftBoxStyles = () => {
    if (downMd) {
      return {
        height: 200,
        width: "100%",
        overflow: "auto",
        position: "relative",
      };
    } else if (downXl) {
      return {
        height: 300,
        width: "100%",
        overflow: "auto",
        position: "relative",
      };
    } else {
      return {
        height: 380,
        width: "100%",
        overflow: "auto",
        position: "relative",
      };
    }
  };

  return (
    <Container>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
        }}
      >
        <Box
          width="100%"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "26px 0px 10px 0px",
          }}
        >
          <Typography
            variant={"body1"}
            fontWeight={500}
            color={colors.black[500]}
          >
            {operation === "bulk-lend"
              ? `Scholar Address`
              : "Recipient Address"}
          </Typography>

          {instances.length > 1 && currentInstance !== 0 && (
            <CrossBox
              onClick={() => {
                setSelectedNftCopy([...selectedNftCopy, ...droppedNfts]);
                removeInstance(currentInstance);
                setCurrentInstance(currentInstance - 1);
              }}
            >
              <img src={cancelIcon} alt="cross" />
            </CrossBox>
          )}
        </Box>

        <Box
          width="100%"
          height="49px"
          bgcolor={"#F9F8FD"}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& input": {
              textAlign: "left",
            },
          }}
        >
          <InputBase
            sx={{
              flex: 1,
              fontSize: "14px",
              border: "1px solid #E8ECF5",
              borderRadius: "7px",
              height: "100%",
              pl: 2,
            }}
            value={scholarAddress}
            onChange={(e) =>
              updateInstance(currentInstance, {
                scholarAddress: e.target.value,
              })
            }
            placeholder="Enter Address"
          />
        </Box>
      </Box>

      {operation === "bulk-transfer" && type === "ERC1155" && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
          }}
        >
          <Box
            width="100%"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "26px 0px 10px 0px",
            }}
          >
            <Typography
              variant={"body1"}
              fontWeight={500}
              color={colors.black[500]}
            >
              Amount
            </Typography>
          </Box>

          <Box
            width="100%"
            height="49px"
            bgcolor={"#F9F8FD"}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "& input": {
                textAlign: "left",
              },
            }}
          >
            <InputBase
              sx={{
                flex: 1,
                fontSize: "14px",
                border: "1px solid #E8ECF5",
                borderRadius: "7px",
                height: "100%",
                pl: 2,
              }}
              value={amount}
              onChange={(e) => {
                const { value } = e.target;

                const reg = /^[0-9\b]+$/;
                const test = reg.test(value);

                const nftsForBalances = selectedNftCopy.length
                  ? selectedNftCopy
                  : droppedNfts;
                const allBalances = nftsForBalances.map((nft) =>
                  Number(nft.balance)
                );

                if (
                  (!test && !isBackeSpacePressed) ||
                  Number(value) > Math.min(...allBalances)
                ) {
                  return;
                }

                updateInstance(currentInstance, {
                  amount: e.target.value,
                });
              }}
              onKeyDown={(event) => {
                if (event.keyCode === 8) {
                  setIsBackeSpacePressed(true);
                } else {
                  setIsBackeSpacePressed(false);
                }
              }}
              placeholder="Amount"
            />
          </Box>
        </Box>
      )}

      {/* {
        operation === "bulk-send" && selectedNftCopy[0]?.contractType === "ERC1155" && 
      }
 */}

      {operation === "bulk-lend" && (
        <>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            <Box
              width="100%"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "26px 0px 10px 0px",
              }}
            >
              <Typography
                variant={"body1"}
                fontWeight={500}
                color={colors.black[500]}
              >
                Yield Destination Address
              </Typography>
            </Box>

            <Box
              width="100%"
              height="49px"
              bgcolor={"#F9F8FD"}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& input": {
                  textAlign: "left",
                },
              }}
            >
              <InputBase
                sx={{
                  flex: 1,
                  fontSize: "14px",
                  border: "1px solid #E8ECF5",
                  borderRadius: "7px",
                  height: "100%",
                  pl: 2,
                }}
                value={rewardTokenAddress}
                onChange={(e) =>
                  updateInstance(currentInstance, {
                    rewardTokenAddress: e.target.value,
                  })
                }
                placeholder="Enter Address"
              />
            </Box>
          </Box>

          {type === "ERC1155" && (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
              }}
            >
              <Box
                width="100%"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "26px 0px 10px 0px",
                }}
              >
                <Typography
                  variant={"body1"}
                  fontWeight={500}
                  color={colors.black[500]}
                >
                  Amount
                </Typography>
              </Box>

              <Box
                width="100%"
                height="49px"
                bgcolor={"#F9F8FD"}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "& input": {
                    textAlign: "left",
                  },
                }}
              >
                <InputBase
                  sx={{
                    flex: 1,
                    fontSize: "14px",
                    border: "1px solid #E8ECF5",
                    borderRadius: "7px",
                    height: "100%",
                    pl: 2,
                  }}
                  value={amount}
                  onChange={(e) => {
                    const { value } = e.target;

                    const reg = /^[0-9\b]+$/;
                    const test = reg.test(value);

                    const nftsForBalances = selectedNftCopy.length
                      ? selectedNftCopy
                      : droppedNfts;
                    const allBalances = nftsForBalances.map((nft) =>
                      Number(nft.balance)
                    );

                    if (
                      (!test && !isBackeSpacePressed) ||
                      Number(value) > Math.min(...allBalances)
                    ) {
                      return;
                    }

                    updateInstance(currentInstance, {
                      amount: e.target.value,
                    });
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 8) {
                      setIsBackeSpacePressed(true);
                    } else {
                      setIsBackeSpacePressed(false);
                    }
                  }}
                  placeholder="Amount"
                />
              </Box>
            </Box>
          )}

          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            <Box
              width="100%"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "26px 0px 10px 0px",
              }}
            >
              <Typography
                variant={"body1"}
                fontWeight={500}
                color={colors.black[500]}
              >
                Split Earnings
              </Typography>
            </Box>

            <Box
              width="100%"
              // height="49px"

              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: "row",
                margin: "0px auto",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  width: "200px",
                  borderRadius: "6px",
                  border: "1px solid #E8ECF5",
                  marginRight: "10px",
                  "& input": {
                    textAlign: "right",
                    // border: "1px solid red",
                    width: "50%",
                  },
                  "& .MuiInputBase-root": {
                    // align: "center",
                    // border: "1px solid green",
                  },
                }}
                bgcolor={colors.whiteAccent[900]}
              >
                <Typography
                  variant={"overline"}
                  fontWeight={400}
                  color={colors.black[500]}
                >
                  Guild
                </Typography>
                <InputBase
                  sx={{
                    flex: 1,
                    fontSize: "14px",
                    border: "1px solid #E8ECF5",
                    height: "100%",
                    backgroundColor: "#F9F8FD",
                  }}
                  value={split}
                  placeholder="0"
                  endAdornment={
                    <InputAdornment position="end">%</InputAdornment>
                  }
                  onChange={(e) => {
                    // const { value } = e.target;

                    let value = e.target.value.replace(" %", "");
                    // e.target.value.length === 1
                    //   ? e.target.value
                    //   : e.target.value.slice(0, e.target.value.length - 1);

                    const reg = /^[0-9\b]+$/;
                    const test = reg.test(value);

                    if (
                      (!test && !isBackeSpacePressed) ||
                      Number(value) > 100
                    ) {
                      return;
                    }

                    if (isBackeSpacePressed) console.log("value mitao");

                    updateInstance(currentInstance, { split: `${value}` });
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 8) {
                      setIsBackeSpacePressed(true);
                    } else {
                      setIsBackeSpacePressed(false);
                    }
                  }}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  width: "200px",
                  borderRadius: "6px",
                  border: "1px solid #E8ECF5",
                  "& input": {
                    textAlign: "right",
                    width: "50%",
                  },
                }}
                bgcolor={colors.whiteAccent[900]}
              >
                <Typography
                  variant={"overline"}
                  fontWeight={400}
                  color={colors.black[500]}
                >
                  Scholar
                </Typography>
                <InputBase
                  sx={{
                    flex: 1,
                    fontSize: "14px",
                    border: "1px solid #E8ECF5",
                    height: "100%",
                    backgroundColor: "#F9F8FD",
                  }}
                  placeholder={"0"}
                  // sx={{ width: "70%", height: "20px" }}
                  endAdornment={
                    <InputAdornment position="end">%</InputAdornment>
                  }
                  value={split.length > 0 ? Math.abs(split - 100) : ""}
                  onChange={(e) => {
                    console.log("disbale");
                  }}
                />
              </Box>
            </Box>
          </Box>
        </>
      )}

      <NftRow>
        <Typography
          variant={"body1"}
          fontWeight={500}
          color={colors.black[500]}
          marginBottom={"10px"}
        >
          NFTs
        </Typography>

        <Box style={NftBoxStyles()}>
          {droppedNfts.map((nft) => (
            <Box
              style={{
                position: "relative",
                width: "55px",
                height: "60px",
                marginLeft: "10px",
                display: "inline-block",
              }}
            >
              <img
                src={deleteIcon}
                onClick={() => {
                  // setDroppedNfts(
                  //   droppedNfts.filter((nftC) => nftC.tokenId !== nft.tokenId)
                  // );
                  updateInstance(currentInstance, {
                    droppedNfts: [
                      ...instances[currentInstance].droppedNfts.filter(
                        (nftC) => nftC.tokenId !== nft.tokenId
                      ),
                    ],
                  });
                  const updSelectedNftCopy = [...selectedNftCopy, nft];
                  setSelectedNftCopy(updSelectedNftCopy);
                }}
                alt="delete"
                style={{
                  position: "absolute",
                  width: "15px",
                  height: "15px",
                  right: -10,
                  // top: -10,
                  zIndex: 10,
                }}
              />
              <img
                src={nft?.image}
                onError={(e) =>
                  (e.currentTarget.src =
                    "https://testnets.opensea.io/static/images/placeholder.png")
                }
                alt="nft view"
                style={{
                  width: "55px",
                  height: "60px",
                  borderRadius: 5,
                  border: "1px solid #6A27EA",
                  margin: 5,
                }}
              />
            </Box>
          ))}
          {isOver && (
            <Typography
              variant={"fs14"}
              fontWeight={700}
              marginBottom={20}
              sx={{ position: "absolute", top: "40%", right: "40%" }}
            >
              Drop Here!
            </Typography>
          )}
        </Box>
      </NftRow>

      <LastRow>
        <img
          src={leftArrow}
          alt="left arrow"
          onClick={() => {
            if (currentInstance === 0) return;
            setCurrentInstance(currentInstance - 1);
          }}
          style={{ opacity: currentInstance === 0 ? 0.5 : 1 }}
        />

        {currentInstance === instances.length - 1 &&
          (operation === "bulk-lend" ? (
            <Button
              onClick={() => addInstance()}
              sx={{
                width: "168px",
                height: "40px",
                border: `1px solid ${colors.primary[500]}`,
                color: colors.primary[500],
                backgroundColor: colors.whiteAccent[900],
                borderRadius: "7px",
                fontSize: "12px",
                fontWeight: 400,
                "&:hover": {
                  color: colors.whiteAccent[900],
                  backgroundColor: colors.primary[500],
                },
              }}
              disabled={
                type === "ERC1155"
                  ? !instances[currentInstance].scholarAddress.length ||
                    !instances[currentInstance].rewardTokenAddress.length ||
                    !instances[currentInstance].split.length ||
                    !instances[currentInstance]?.amount?.length ||
                    !instances[currentInstance].droppedNfts.length
                  : !instances[currentInstance].scholarAddress.length ||
                    !instances[currentInstance].rewardTokenAddress.length ||
                    !instances[currentInstance].split.length ||
                    !instances[currentInstance].droppedNfts.length
              }
              variant={"outlined"}
            >
              Add New Scholar
            </Button>
          ) : (
            <Button
              onClick={() => addInstance()}
              sx={{
                width: "168px",
                height: "40px",
                border: `1px solid ${colors.primary[500]}`,
                color: colors.primary[500],
                backgroundColor: colors.whiteAccent[900],
                borderRadius: "7px",
                fontSize: "12px",
                fontWeight: 400,
                visibility: type === "ERC1155" ? "hidden" : "visible",
                "&:hover": {
                  color: colors.whiteAccent[900],
                  backgroundColor: colors.primary[500],
                },
              }}
              disabled={
                type === "ERC1155"
                  ? !instances[currentInstance].scholarAddress.length ||
                    !instances[currentInstance].amount.length ||
                    !instances[currentInstance].droppedNfts.length
                  : !instances[currentInstance].scholarAddress.length ||
                    !instances[currentInstance].droppedNfts.length
              }
              variant={"outlined"}
            >
              Add New Address
            </Button>
          ))}
        <img
          src={rightArrow}
          alt="left arrow"
          onClick={() => {
            if (currentInstance === instances.length - 1) return;
            setCurrentInstance(currentInstance + 1);
          }}
          style={{
            width: "32px",
            height: "32px",
            opacity: currentInstance === instances.length - 1 ? 0.5 : 1,
          }}
        />
      </LastRow>
    </Container>
  );
}
